<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="benefitForm">
                    <div class="forms-container">
                        <div class="row no-margin">
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="typeName">Type Name :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="typeName" type="text" class="form-control" id="typeName" placeholder="Type Name">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{typeNameError}}</font>
                                </div>
                            </div>
                            <!--Error Alert-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addBenifitBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addBenefitType()">
                                    <input id="addAndContinueBenifitBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addBenefitType(flag='Save and Continue')">
                                    <input id="CancelBenifit" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';

    export default {
        name: 'AddBenefits',
        components: {
            'app-backend-footer': BackendFooter,
            'v-select': vSelect,
        },
        mixins: [SessioMixin],
        data() {
            return {
                pageTitle: 'Add Benefits Type',
                typeName: '',
                typeNameError: '',
            }
        },

        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self = this;
            self.showLoader();
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[2] == 'updatebenefitstype') {
                if (segments[3]) {
                    self.pageTitle = 'Edit Benefits Type';
                    self.loadBenefitType();
                    $("#addAndContinueBenifitBtn").hide();
                    $("#addBenifitBtn").val("Update");
                    $("#benefitHeader").text("Edit Benefit Video");
                }
            } else {
                self.hideLoader();
            }
            $("#typeName").on('keyup', function () {
                self.typeNameError = '';
            });
            $("#alertError").hide();
        },
        methods: {
            buttonBack() {
                $(".back_button").prop("disabled", false);
                self.$router.push('/backend/listbenefittypes');
            },

            checkForm: function () {
                var checked = true;
//                self.typeName = "";

                if (!self.typeName) {
                    self.typeNameError = "Type Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },

            addBenefitType(flag) {
                self.checkForm();
                if (self.checkForm()) {
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };

                    if (segments[2] == 'updatebenefitstype') {
                        if (segments[3]) {
                            var data = {
                                name: self.typeName,
                                id: segments[3],
                            };
                            $("#addBenifitBtn").val("Updating ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueBenifitBtn").val("Saving ...");
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            } else {
                                $("#addBenifitBtn").val("Saving ...");
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            }
                        }
                    } else {
                        var data = {
                            name: self.typeName,
                        };
                        if (flag == "Save and Continue") {
                            $("#addAndContinueBenifitBtn").val("Saving ...");
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            $("#addBenifitBtn").val("Saving ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        }
                    }
                    self.showLoader();
                    HTTP.post("addupdatebenifittype", data, config)
                            .then(function (response) {
//                        console.log(response.data.content);
                                if (segments[2] == 'updatebenefitstype') {
                                    if (segments[3]) {
                                        //console.log(segments[3]);
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    }
                                }

                                if (response.data.message == "success") {
                                    // self.$router.push('/task/list');
                                    $("#errorMsg").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    if (flag == "Save and Continue") {
//                                $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").addClass("show");
                                        self.typeName = '';
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $(".back_button").prop("disabled", true);
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    $("#alertError").show();

                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                if (segments[2] == 'updatebenefitstype') {
                                    if (segments[3]) {
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            self.typeName = '';
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        self.typeName = '';
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                                self.hideLoader();
                            });
                }
            },

            loadBenefitType: function () {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var data = {
                    id: segments[3],
                };
                self.showLoader();
                HTTP.post("getbenifittypes/" + segments[3], data, config)
                        .then(function (response) {
                            self.typeName = response.data.content[0].name;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/benefits/AddBenefitType.vue